


























































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import moment from "moment";
import "@/assets/css/table.css";
import SearchTree from "@/lib/Common/searchtree";

class PageMeterRequest extends PageRequest {
  keyword: string;
  areaId: number;
  onlyNo: number;
  modelId: number = 0;
  applicationId: number = 0;
  transferType: number = 0;
  meterType: number = 0;
  controleType: number = 0;
  isEnabel: number = 9; //nullable
  deviceLevel: number = 0;
  selectedId: any[] = [];
}

@Component({
  components: {},
})
export default class ChooseMeter extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Array, default: [] }) meterlist: Array<any>;
  @Prop({ type: Number, default: 0 }) devicelevel: number;
  @Prop({ type: Array, default: [] }) selecteddevice: Array<any>;
  //filters
  pagerequest: PageMeterRequest = new PageMeterRequest();
  choosemeterlist: any[] = [];
  areaTree: any[] = []; //左边树形结构
  areaTreeList: any[] = [];
  searchName: string = "";
  height: number = 300; //表格高度
  selectlist: any[] = []; //已选择列表需要返回
  selectstr: string = ""; //显示字符串
  //选择
  onrowselect(val, index) {
    this.choosemeterlist.push(index.meterNo);
    this.formselect();
    this.selectlist.push(index);
  }
  //取消选择
  onrowselected(val, index) {
    this.choosemeterlist = this.choosemeterlist.filter((ele) => {
      return ele != index.meterNo;
    });
    this.selectlist = this.selectlist.filter((ele) => {
      return ele.id != index.id;
    });
    this.formselect();
  }
  //全选
  selectall() {
    let val = (this.$refs.choosemeters as any).getSelection();
    if (val.length > 0) {
      val.forEach((ele) => {
        this.choosemeterlist.push(ele.meterNo);
        this.selectlist.push(ele);
      });
    }
    this.formselect();
  }
  //取消全选
  cancelselectall() {
    this.selectlist = [];
    this.choosemeterlist = [];
    this.selectstr = "";
    this.formselect();
  }
  //格式化选中数据
  formselect() {
    this.selectstr = "";
    this.choosemeterlist.forEach((ele) => {
      if (this.selectstr.length == 0) {
        this.selectstr = ele;
      } else {
        this.selectstr = this.selectstr + ";" + ele;
      }
    });
  }
  //确认数据
  save() {
    this.$emit("devicelist", this.selectlist); //回传给父组件
    this.$emit("input", false);
  }
  cancel() {
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    //this.selectlist = [];
    if (!value) {
      this.$emit("input", value);
    } else {
      this.getpage();
      this.selectlist = [];
      this.choosemeterlist = [];
      this.selectstr = "";
    }
  }
  //改变排序
  changeSort(key) {
    if (key.order !== "normal") {
      this.pagerequest.sorting = key.key + " " + key.order;
    }
    this.getpage();
  }
  get list() {
    return this.$store.state.meterlist.list;
  }
  get loading() {
    return this.$store.state.meterlist.loading;
  }
  isActiveChange(val: number) {
    this.pagerequest.isEnabel = val;
    this.$store.commit("meterlist/setCurrentPage", 1);
    this.getpage();
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.pagerequest.areaId = item[0].id;
    }
    this.$store.commit("meterlist/setCurrentPage", 1);
    this.getpage();
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.areaTree = this.areaTreeList;
      return;
    }
    this.areaTree = SearchTree.searnchTree(value, treeList);
  }
  async getAreaTree() {
    await this.$store
      .dispatch("area/getAreaLeftTree")
      .then((val) => {
        this.areaTree = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  //改变页
  pageChange(page: number) {
    this.$store.commit("meterlist/setCurrentPage", page);
    this.getpage();
  }
  //改变显示记录
  pagesizeChange(pagesize: number) {
    this.$store.commit("meterlist/setPageSize", pagesize);
    this.getpage();
  }
  //获取数据
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "meterlist/findMeterList",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.meterlist.pageSize;
  }
  get totalCount() {
    return this.$store.state.meterlist.totalCount;
  }
  get currentPage() {
    return this.$store.state.meterlist.currentPage;
  }
  columns = [
    {
      type: "index",
      width: 80,
      align: "left",
      title: this.L("IndexNo"),
    },
    {
      type: "selection",
      width: 60,
      align: "center",
      fixed: "left",
      sortId: 1,
    },
    {
      title: this.L("Areas"),
      key: "areaName",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.areaName,
            },
          },
          params.row.areaName
        );
      },
    },
    {
      title: this.L("Meter"),
      key: "meterNo",
      sortable: true,
      width: 180,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.meterNo,
            },
          },
          params.row.meterNo
        );
      },
    },
    {
      title: this.L("RoomNo"),
      key: "roomNo",
      width: 150,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.roomNo,
            },
          },
          params.row.roomNo
        );
      },
    },
    {
      title: this.L("ControleType"),
      key: "controleType",
      width: 130,
      sortable: true,
      sortId: 3,
      render: (h: any, params: any) => {
        let id = params.row.controleType;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : "未知");
      },
    },
    {
      title: this.L("ReadTime"),
      key: "lastReadTime",
      width: 150,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.lastReadTime == null
            ? ""
            : moment(params.row.lastReadTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("LastReadNum"),
      key: "lastReadNum",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("CurrentTenant"),
      key: "customerName",
      sortable: true,
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.customerName,
            },
          },
          params.row.customerName
        );
      },
    },
    {
      title: this.L("Location"),
      key: "location",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.location,
            },
          },
          params.row.location
        );
      },
    },
  ];
  created() {
    this.getAreaTree();
    this.pagerequest.isEnabel = 9;
  }
  data() {
    return {
      applicationType: [],
      transferType: [],
      meterType: [],
      controleType: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
  @Watch("meterlist", { deep: true })
  @Watch("devicelevel", { deep: true })
  @Watch("selecteddevice", { deep: true })
  getitemId() {
    this.choosemeterlist = this.meterlist;//已选择表计
    this.pagerequest.selectedId = this.meterlist;
    this.pagerequest.deviceLevel = this.devicelevel;
    this.selectlist = this.selecteddevice;
  }
}
